import { MBSAccessHelper, Module, Privilege } from '@fides/fides-react-components';

export function hasAccessToModuleOrImpersonated(accessHelper: MBSAccessHelper, module: Module): boolean {
  return (
    (accessHelper.hasAccessForModule(module) && !accessHelper.hasPermissionForModule(module, Privilege.DENY)) ||
    (accessHelper.isAnyFidesAdmin() && !accessHelper.isImpersonated) ||
    accessHelper.isImpersonatedAsClient
  );
}
